import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

export class StringSelectFilter extends Component {
    constructor(props) {
        super(props);

        this.filter = this.filter.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
    }

    filter(event) {
        if (event.target.value === 'Any') {
            this.props.filterHandler();
        } else {
            const targetValue = event.target.value; // Event will be eaten for some reason without copy here
            this.props.filterHandler({callback: target =>  this.props.items[target] === targetValue});
        }
    }

    cleanFiltered() {
        this.filterControl.selectedIndex = 0;
        this.props.filterHandler();
    }

    createSelectItems() {
        let selectItems = [];
        let filterStrings = ['Any', ..._.values(this.props.items)];

        for (let i = 0; i < filterStrings.length; i++) {
            var valString = filterStrings[i];
            selectItems.push(<option key={i} value={valString}>{valString}</option>);
        }

        return selectItems;
    }

    render() {
        return (
            <FormControl ref={x => this.filterControl = x} componentClass={'select'} onChange={this.filter}>
            {this.createSelectItems()}
            </FormControl>
        );
    }
}

StringSelectFilter.propTypes = {
    filterHandler: PropTypes.func.isRequired,
    items:         PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/table/StringSelectFilter.js